import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    MultiSelectBox,
    SearchDateBox,
    SearchBox,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    Barcode,
    Title,
    TextView,
    PanelBox,
    Modal,
} from '../../components/Display';
import TaroffOrdersView from '../orders/TaroffOrdersView';
import { postData } from '../../Api';

export default function TaroffOrdersSpecialReport(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp2 = () => {
        console.log('handlecomp2');
    };
    const handlecomp1 = () => {
        const childDialog = (
            <>
                <Button onClick={handlecomp2} color={'secondary'}>
                    پرینت
                </Button>
                <TableData
                    total={tableData.total}
                    size={tableSize}
                    page={tablePage}
                    setPage={gotoPage}
                >
                    <TableHeader>
                        <TableRow>
                            <TableColumn mobile={false}>شناسه</TableColumn>
                            <TableColumn mobile={false}>عنوان</TableColumn>
                            <TableColumn mobile={false}>زمان ایجاد</TableColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {tableData.rows?.map((row, index) => (
                            <TableRow key={index}>
                                <TableColumn mobile={false}>
                                    <TextView>{row.text_id}</TextView>
                                </TableColumn>
                                <TableColumn mobile={false}>
                                    <Barcode barcode={row.text_post_barcode} />
                                </TableColumn>
                                <TableColumn mobile={false}>
                                    <TextView format={'persian-date-normal'}>
                                        {row.text_inserttime}
                                    </TextView>
                                </TableColumn>
                            </TableRow>
                        ))}
                    </TableBody>
                </TableData>
            </>
        );
        setModal(
            Modal({
                children: childDialog,
                onDismiss: () => setModal(null),
            })
        );
        console.log('child-dialog');
    };
    const [formQShopIdOptions, setFormQShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-special-report/select-data/q-shop-id').then(
            (response) => {
                setFormQShopIdOptions(response.data);
            }
        );
    }, []);
    const [formQStateIdOptions, setFormQStateIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-special-report/select-data/q-state-id').then(
            (response) => {
                setFormQStateIdOptions(response.data);
            }
        );
    }, []);
    const [formQCarrierIdOptions, setFormQCarrierIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-special-report/select-data/q-carrier-id').then(
            (response) => {
                setFormQCarrierIdOptions(response.data);
            }
        );
    }, []);
    const [formQPaymentMethodIdOptions, setFormQPaymentMethodIdOptions] = useState([]);
    useEffect(() => {
        postData(
            '/api/panel/page/taroff-orders-special-report/select-data/q-payment-method-id'
        ).then((response) => {
            setFormQPaymentMethodIdOptions(response.data);
        });
    }, []);
    const handlecomp3 = () => {
        applyFilters();
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQId('');
        setFilterQShopId('');
        setFilterQStateId('');
        setFilterQCarrierId('');
        setFilterQPaymentMethodId('');
        setFilterQInsertTimeFrom('');
        setFilterQInsertTimeTo('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQId && (newSearchParams['q-id'] = filterQId);
        filterQShopId && (newSearchParams['q-shop-id'] = filterQShopId);
        filterQStateId && (newSearchParams['q-state-id'] = filterQStateId);
        filterQCarrierId && (newSearchParams['q-carrier-id'] = filterQCarrierId);
        filterQPaymentMethodId && (newSearchParams['q-payment-method-id'] = filterQPaymentMethodId);
        filterQInsertTimeFrom && (newSearchParams['q-insert-time-from'] = filterQInsertTimeFrom);
        filterQInsertTimeTo && (newSearchParams['q-insert-time-to'] = filterQInsertTimeTo);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQId, setFilterQId] = useState(allProps['q-id'] || '');
    const [filterQShopId, setFilterQShopId] = useState(allProps['q-shop-id'] || '');
    const [filterQStateId, setFilterQStateId] = useState(allProps['q-state-id'] || '');
    const [filterQCarrierId, setFilterQCarrierId] = useState(allProps['q-carrier-id'] || '');
    const [filterQPaymentMethodId, setFilterQPaymentMethodId] = useState(
        allProps['q-payment-method-id'] || ''
    );
    const [filterQInsertTimeFrom, setFilterQInsertTimeFrom] = useState(
        allProps['q-insert-time-from'] || ''
    );
    const [filterQInsertTimeTo, setFilterQInsertTimeTo] = useState(
        allProps['q-insert-time-to'] || ''
    );
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-special-report/table-data', {
            size: tableSize,
            page: tablePage,
            q_id: filterQId,
            q_shop_id: filterQShopId,
            q_state_id: filterQStateId,
            q_carrier_id: filterQCarrierId,
            q_payment_method_id: filterQPaymentMethodId,
            q_insert_time_from: filterQInsertTimeFrom,
            q_insert_time_to: filterQInsertTimeTo,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handlecomp4 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersView
                        taroff-orders-id={row.param_id}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>گزارش ویژه سفارشات</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp1} color={'secondary'}>
                        بارکد ها
                    </Button>
                </LeftComponents>
            </Row>
            <SearchBox onEnter={applyFilters} label={'شناسه'} value={filterQId} onChange={setFilterQId} width={'120px'} />
            <MultiSelectBox
                label={'فروشگاه'}
                options={formQShopIdOptions}
                value={filterQShopId}
                onChange={setFilterQShopId}
            />
            <MultiSelectBox
                label={'وضعیت'}
                options={formQStateIdOptions}
                value={filterQStateId}
                onChange={setFilterQStateId}
            />
            <MultiSelectBox
                label={'حامل'}
                options={formQCarrierIdOptions}
                value={filterQCarrierId}
                onChange={setFilterQCarrierId}
            />
            <MultiSelectBox
                label={'شیوه ی پرداخت'}
                options={formQPaymentMethodIdOptions}
                value={filterQPaymentMethodId}
                onChange={setFilterQPaymentMethodId}
            />
            <SearchDateBox onEnter={applyFilters}
                label={'زمان درج از'}
                value={filterQInsertTimeFrom}
                onChange={setFilterQInsertTimeFrom}
                width={'100px'}
            />
            <SearchDateBox onEnter={applyFilters}
                label={'زمان درج تا'}
                value={filterQInsertTimeTo}
                onChange={setFilterQInsertTimeTo}
                width={'100px'}
            />
            <Button onClick={handlecomp3} color={'secondary'}>
                جستجو
            </Button>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>فروشگاه</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>ارسال</TableColumn>
                        <TableColumn mobile={false}>پرداخت</TableColumn>
                        <TableColumn mobile={false}>مبلغ کل</TableColumn>
                        <TableColumn mobile={false}>وضعیت</TableColumn>
                        <TableColumn mobile={false}>زمان ایجاد</TableColumn>
                        <TableColumn mobile={false}>یادداشت ویژه</TableColumn>
                        <TableColumn mobile={false}></TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id_2}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_shop_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_carrier_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_payment_method_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'money'}>{row.text_total_list_price}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView backColor={row.color_state_id_color}>
                                    {row.text_state_id_title}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-date-normal'}>
                                    {row.text_inserttime_2}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_special_note}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <Button
                                    onClick={() => handlecomp4(row)}
                                    rightIcon={'far fa-info'}
                                    tooltip={'Taroff Orders View'}
                                ></Button>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
